import { Component } from '@angular/core';
import { SidenavBaseFilterComponent } from '../../../../../core/base/components/sidenav/base-filter/sidenav-base-filter.component';
import { EQUIPMENT_FILTER_SCHEMA, toMetrikStatusOption } from './equipment-filter.schema';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { EstablishmentService } from '../../establishment/establishment.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { GenericEquipmentService } from '../../../settings/generic-equipment/generic-equipment.service';
import { EquipmentService } from '../equipment.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { MetrikStatusModuleEnum } from '../../../../../core/enums/metrik-status.enum';
import { GenericMetrikStatusService } from '../../../settings/generic-metrik-status/generic-metrik-status.service';

@Component({
  selector: 'equipment-filter',
  templateUrl: './equipment-filter.component.html',
  styleUrls: ['./equipment-filter.component.scss'],
})
export class EquipmentFilterComponent extends SidenavBaseFilterComponent {
  override readonly schema = EQUIPMENT_FILTER_SCHEMA;
  showEstablishments: boolean;

  constructor(
    public establishmentService: EstablishmentService,
    public userService: UserProfileService,
    public genericEquipmentService: GenericEquipmentService,
    public metrikStatusService: GenericMetrikStatusService,
    public equipmentService: EquipmentService,
    public authService: AuthService,
    public snackbarService: SnackbarService,
    public autocompleteService: AutocompleteService,
  ) {
    super(snackbarService, autocompleteService);

    this.showEstablishments = this.authService.currentUserValue().affectations.length > 1;

    this.addForm(
      'standardForm',
      new UntypedFormGroup({
        technicalIdentifier: new UntypedFormControl(),
        reference: new UntypedFormControl(),
        establishments: new UntypedFormControl(),
        genericEquipments: new UntypedFormControl(),
        serialNumber: new UntypedFormControl(),
        mark: new UntypedFormControl(),
        model: new UntypedFormControl(),
        contactIntern: new UntypedFormControl(),
        metrikStatus: new UntypedFormControl(),
      }),
    );

    this.addForm(
      'commissioningDate',
      new UntypedFormGroup({
        comparison: new UntypedFormControl(),
        min: new UntypedFormControl(),
        max: new UntypedFormControl(),
      }),
    );
  }

  autocompleteEstablishment(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'establishments', '_id', pageToGo, (page, size) =>
        this.establishmentService.findAll(page, size, 'label', 'asc', search, { onlyMine: true }),
      )
      ?.subscribe();
  }

  autocompleteUsers(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'users', '_id', pageToGo, (page, size) =>
        this.userService.findAll(page, size, 'lastName', 'asc', search, { isSupervision: true }),
      )
      ?.subscribe();
  }

  autocompleteGenericEquipments(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'genericEquipments', '_id', pageToGo, (page, size) =>
        this.genericEquipmentService.findAll(page, size, 'label', 'asc', search),
      )
      ?.subscribe();
  }

  /** Via AutocompleteService (et non un Observable local) : la restauration des chips y injecte les statuts choisis. */
  autocompleteMetrikStatus(search: string = '', pageToGo?: 'next' | 'previous') {
    const filters = { modules: [MetrikStatusModuleEnum.EQUIPMENT], requiredFields: ['*'] };

    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'metrikStatus', '_id', pageToGo, (page, size) =>
        this.metrikStatusService
          .findAll(page, size, 'type', 'asc', search, filters)
          .pipe(map(response => ({ ...response, data: response.data.map(toMetrikStatusOption) }))),
      )
      ?.subscribe();
  }

  autocompleteEquipmentInfiniteScrollField(search: string = '', filterName: string, pageToGo?: 'next' | 'previous') {
    const data = this.autocompleteService.autocompleteInfiniteScroll(
      search,
      filterName,
      filterName,
      pageToGo,
      (page, size) =>
        this.equipmentService.findAll(page, size, filterName, 'asc', search, {
          onlyDistinctField: filterName,
          requiredFields: [filterName],
        }),
    );

    data.subscribe();
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string) {
    switch (filterField) {
      case 'establishments':
        this.autocompleteEstablishment('', pageToGo);
        break;
      case 'users':
        this.autocompleteUsers('', pageToGo);
        break;
      case 'genericEquipments':
        this.autocompleteGenericEquipments('', pageToGo);
        break;
      case 'metrikStatus':
        this.autocompleteMetrikStatus('', pageToGo);
        break;
      case 'mark':
      case 'model':
      case 'serialNumber':
        this.autocompleteEquipmentInfiniteScrollField('', filterField, pageToGo);
        break;
      default:
        console.error('Unknown filterField:', filterField);
    }
  }
}
